var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('transition-group', {
    staticClass: "tag-wrapper",
    attrs: {
      "css": false
    },
    on: {
      "enter": _vm.enter,
      "afterEnter": _vm.afterEnter,
      "leave": _vm.leave
    }
  }, [_vm._l(_vm.activeSubsections, function (subsection, index) {
    return [subsection.showOnMap ? _vm._l(subsection.markers, function (marker) {
      return _c('tag-basic', _vm._b({
        key: subsection._id + '_tag',
        class: {
          'tag-basic--sold-out': _vm.isSoldOut(subsection)
        },
        attrs: {
          "pos": {
            x: marker.x,
            y: marker.y
          },
          "show-sold-label": _vm.showSoldLabel(subsection),
          "label": subsection.displayName,
          "filtered": subsection.filtered
        },
        nativeOn: {
          "click": function click($event) {
            return _vm.navigateToChild(subsection);
          }
        }
      }, 'tag-basic', marker, false));
    }) : _vm._e(), subsection.showOnMap ? _vm._l(subsection.polygons, function (polygon) {
      return _c('polygon-shape', {
        key: polygon._id,
        class: {
          'polygon-overlay--sold-out': _vm.isSoldOut(subsection)
        },
        attrs: {
          "polygon": polygon,
          "to": _vm.polygonUrl(subsection),
          "filtered": subsection.filtered
        }
      });
    }) : _vm._e()];
  })], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }